import { ref, computed, type Ref, type ComputedRef } from 'vue';

type Options<T> = {
  items: Ref<T[]> | ComputedRef<T[]>;
  limit: number;
};

export const useExpandableList = <T>({ items, limit }: Options<T>) => {
  const isExpanded = ref(false);

  const visibleItems = computed(() =>
    isExpanded.value ? items.value : items.value.slice(0, limit)
  );

  const hasMore = computed(() => items.value.length > limit);

  return {
    isExpanded,
    visibleItems,
    hasMore,
    totalCount: computed(() => items.value.length),
  };
}
